import * as mruTableIdList from './mruTableIdList';
import updateAlwaysInCacheTableViews from './updateAlwaysInCacheTableViews';
import getSortByFolderId from 'owa-mail-folder-store/lib/selectors/getSortByFolderId';
import TableView from 'owa-mail-list-store/lib/store/schema/TableView';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { getViewFilterForTable, TableQueryType, MailFolderTableQuery } from 'owa-mail-list-store';

export default function updateTablesInCache(tableView: TableView): number | undefined {
    if (tableView.tableQuery.type == TableQueryType.Search) {
        throw new Error('updateTablesInCache should never be called for Search table');
    }

    const mailTableQuery = tableView.tableQuery as MailFolderTableQuery;

    // Inbox with All filter
    if (
        tableView.tableQuery.folderId === folderNameToId('inbox') &&
        getViewFilterForTable(tableView) === 'All' &&
        mailTableQuery.scenarioType !== 'spotlight'
    ) {
        // Checks the sort preferences of inbox
        const sortColumn = mailTableQuery.sortBy.sortColumn;
        const sortDirection = mailTableQuery.sortBy.sortDirection;
        const folderSettingsSortBy = getSortByFolderId(tableView.tableQuery.folderId);
        if (
            sortColumn === folderSettingsSortBy.sortColumn &&
            sortDirection === folderSettingsSortBy.sortDirection
        ) {
            updateAlwaysInCacheTableViews();
            return 0;
        }
    }

    return mruTableIdList.update(tableView);
}

export function initializeTablesInCache() {
    updateAlwaysInCacheTableViews();
}

export function canAddToMruTableIdList(): boolean {
    return mruTableIdList.canAddToList();
}

// VSO-18425 - refactor the table caching code as per the new design.
// This function should be just remove after the code refactoring
export function removeFromMruTableIdList(tableViewId: string) {
    mruTableIdList.remove(tableViewId);
}
